export default function value(name, props, values) {
  return values[props.theme && props.theme[name]];
}
//# sourceMappingURL=value.js.map